import request from '@/utils/request'

export default {
    getProvince: function () {
        return request({
            url: 'taobaotejia/getProvince',
            method: 'post',
        });
    },
    getCity: function (id) {
        return request({
            url: 'taobaotejia/getCity',
            method: 'post',
            params: {
                id: id,
            }
        });
    },
    apply: function (query) {
        return request({
            url: 'taobaotejia/apply',
            method: 'post',
            params: {
                traderId: query.traderId,
                name: query.name,
                taobaoid: query.taobaoid,
                idno: query.idno,
                mobile: query.mobile,
                province: query.province,
                city: query.city,
            }
        });
    },
    tccApply: function (query) {
        return request({
            url: 'taobaotejia/tccApply',
            method: 'post',
            params: {
                traderId: query.traderId,
                name: query.name,
                taobaoid: query.taobaoid,
                idno: query.idno,
                mobile: query.mobile,
                province: query.province,
                city: query.city,
            }
        });
    },
}
